import ICON__brush_clean from '@/assets/icons/lucide/brush-clean.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_10_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_10_5';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { ENUM__invocation_type } from '@shared/dto/generation/graph_invoke/_invocations/_base/ENUM__invocation_type';

export function G_BUTTON__graph_clear() {
  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   *
   */

  const { graph } = generation_current.tool;

  /*
   * EVENTS
   */
  async function onClick() {
    let graph_new = graph.clone();

    for (let node of graph_new.nodes_map.values()) {
      if (node.type == ENUM__invocation_type.GRID2D__VIEW) continue;

      graph_new.node__delete(node.meta.node_id);
    }

    await UTILS__graph_data.update(graph_new);
  }
  /*
   * METHODS
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  if (graph.nodes_map.size() < 2) return <PLACEHOLDER_BUTTON__bar_10_5 />;

  return (
    <UI_PRIMITIVE__button size="rect-10-6" variant={'no-border-on-component'} disabled={is_disabled()} {...{ onClick }}>
      <ICON__brush_clean className="size-3" />
    </UI_PRIMITIVE__button>
  );
}
